module.exports = __webpack_public_path__ + "static/media/LOGO-CREALIA.59357ea0.png";